<template>

    <m-edit1/>

    <m-single-product-303 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"m-product-card309","relatedPosts":true,"relatedCourse":false,"productInfoTab":"detail","galleryFullSlider":false},...{}}' :style='""' class="" ></m-single-product-303>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct303 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct303';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct303 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
